import React from "react";
import CommonEditor from "components/Common/CommonEditor";

const ContentTabsRefund = ({ desc, data, setData, error, setError }) => {
  const onChangeText = params => {
    const emptyHtmlTagsRegex =
      /<\s*\w+\s*>(\s|&nbsp;|<\/?\s*\w*\s*>)*<\/\s*\w+\s*>/g;
    const cleanedInput = params.replace(emptyHtmlTagsRegex, "");

    if (cleanedInput.length < 5) {
      setError({
        ...error,
        warrant: true,
      });
      return;
    }

    setError({
      ...error,
      warrant: false,
    });
    setData(prevData => ({
      ...prevData,
      policies: {
        ...prevData.policies,
        warrant: cleanedInput,
      },
    }));
  };

  return (
    <div className="tabs-content-input">
      <span className="tabs-content-input-description">{desc}</span>
      <CommonEditor
        className={error.warrant ? "error" : ""}
        onChange={e => onChangeText(e)}
        text={data?.policies?.warrant}
      />
      {error.warrant && (
        <span className="tabs-content-error">
          Kebijakan Garansi tidak boleh kosong
        </span>
      )}
    </div>
  );
};

export default ContentTabsRefund;
